"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'app.pagination.pagnation_info': 'Visualizzando {startItem} a {endItem} di {totalItems} voci',
};
